<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 mx-auto page-card self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <!-- <img src="@/assets/images/pages/register.png" alt="login" class="mx-auto"> -->
              <img src="@/assets/images/logo/logo.png"  alt="login" class="mx-auto page-logo">
              <img src="@/assets/images/pages/banner-img.svg" alt="login" class="mx-auto page-image">
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center">
              <div class="bg-white forgot-password">
                <div>
                  <form autocomplete="off">
                    <div class="vx-card__title mb-8">
                        <h2 class="mb-4">Forgot Password</h2>
                      <p>Please enter email id to send one-time password.</p>
                    </div>
                    <vs-input
                      icon="icon icon-user"
                      v-validate="'required|email'"
                      name="email"
                      icon-pack="feather"
                      label-placeholder="Email"
                      v-model="email"
                      class="w-full no-icon-border"
                      autocomplete="off"
                    />
                    <span class="text-danger text-sm">{{ errors.first('email') }}</span>
                    <button
                      type="button"
                      class="vs-component vs-button float-right mt-6 ml-2 vs-button-warning vs-button-filled"
                      @click.prevent="back()"
                    >Back</button>
                    <vs-button
                      class="float-right mt-6"
                      id="forgot-password"
                      :disabled="button_loading"
                      @click.prevent="sendLink()"
                    >Send</vs-button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
const dict = {
  custom: {
    email: {
      required: "Please enter email",
      email: "Please enter valid email"
    }
  }
};
// register custom messages
Validator.localize("en", dict);
export default {
  data() {
    return {
      email: ''
    };
  },
  computed: {},
  mounted() {},
  methods: {
    sendLink() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.button_loader(true, "#forgot-password");
          let input = {
            email: this.email
          };
          this.axios
            .post("auth/generatePasswordUser", input)
            .then(response => {
              this.button_loader(false, "#forgot-password");
              let text =
                "OTP has been sent to your email. Please check you mail!";
              this.$vs.notify({
                text: text,
                color: "success",
                position: "top-right"
              });
              // console.log('/reset-password?email='+this.email)
              this.$router.push('/reset-password?email='+this.email);
            })
            .catch(e => {
              this.showError(e,"#forgot-password");
            });
        }
      });
    },
    back() {
      this.$router.push({ name: "login" });
    }
  }
};
</script>
<style>

.page-card
{
  align-items: center;
    display: flex;
}
.page-logo {
  max-width: 240px;
}
.page-image {
  max-width: 350px;
}
</style>